// Tag the shared Lity overlay so ONLY video pop-outs (video grid + video
// carousel) get the bounded-modal / obvious-close styling in _lity.scss.
// Every other Lity lightbox on the site keeps Lity's default look.
//
// Lity fires `lity:open` on its overlay with the instance; `instance.opener()`
// is the element that triggered it. If that's one of our video cards we add
// `lity--video-modal` to `instance.element()` (the overlay), which the SCSS
// scopes to.
(function($) {
  var VIDEO_TRIGGERS = ".video-grid__card, .video-carousel__card";

  $(document).on("lity:open", function(event, instance) {
    var opener = instance.opener();
    if (opener && opener.closest(VIDEO_TRIGGERS).length) {
      instance.element().addClass("lity--video-modal");
    }
  });
})(jQuery);
